import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResetSenhaComponent } from './reset-senha.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ThemeModule } from '../../@theme/theme.module';
import { NbCardModule } from '@nebular/theme';

@NgModule({
  declarations: [ResetSenhaComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ThemeModule,
    CommonModule,
    NbCardModule,
    ReactiveFormsModule]
})
export class ResetSenhaModule { }
